import styled from "@emotion/styled";
import React from "react";
import { FC, memo } from "react";
import { sizes } from "../../../../constants/spacing";
import { Checkbox, CheckboxProps } from "../../../checkbox";

const noopClickHandler = () => {
    // Nothing here intentionally - the Checkbox is purely presentational.
    // Its state is controlled by its parents.
};

const MultiSelectCheckboxStyled = memo(styled(Checkbox)`
    margin-right: ${sizes.xSmall}px;
    vertical-align: middle;
`);

type MultiSelectCheckboxProps = Omit<CheckboxProps, "onClick">;

export const MultiSelectCheckbox: FC<MultiSelectCheckboxProps> = (props) => {
    return (
        <MultiSelectCheckboxStyled
            aria-hidden={true}
            omitHiddenInput={true}
            {...props}
            tabIndex={-1}
            onClick={noopClickHandler}
        />
    );
};
